module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.358.9/frontend/_next/static/images/advantages_1_2-f87815f15bc41e6c7e592085d7dd1a95.webp";